import type { DealFormDataWithTargeting } from '@openx/types/deal';
import { TargetingFields } from '@openx/types/targeting/targeting';
import type { RequiredTargetingFormType } from '@openx/types/targeting/targetingPresets';
import { hasRboInState } from './hasRboInFormState';

const getCurrentFormat = (rootForm: DealFormDataWithTargeting | undefined): string | undefined =>
  rootForm?.targeting?.targeting?.[TargetingFields.INVENTORY_FORMAT]?.ad_placement?.val?.toUpperCase();

const getCurrentRenderingContext = (
  rootForm: DealFormDataWithTargeting | undefined
): RequiredTargetingFormType | null =>
  rootForm?.targeting?.targeting?.[TargetingFields.INVENTORY_FORMAT] as RequiredTargetingFormType | null;

export const validateFormatConsistency = (
  groupFormat: string | undefined,
  rootForm: DealFormDataWithTargeting | undefined,
  // biome-ignore lint/suspicious/noExplicitAny: any is needed here
  context: any,
  errorMessage: string
): boolean | ReturnType<typeof context.createError> => {
  if (!groupFormat) {
    return true;
  }

  const currentFormat = getCurrentFormat(rootForm);
  const currentRenderingContext = getCurrentRenderingContext(rootForm);
  const hasRbo = hasRboInState(rootForm);

  if ((!currentFormat && currentRenderingContext) || !hasRbo) {
    return true;
  }

  if (currentFormat !== groupFormat) {
    return context.createError({
      message: errorMessage,
    });
  }

  return true;
};
